module.exports = __webpack_public_path__ + "static/media/brain.628af4e3.png";